import React from 'react'
import { connect } from 'react-redux'
import Icon from '../../components/Icon/Icon'
import TextField from '../../components/TextField/TextField.js'
import { validName, validEmail } from '../../helpers/validation'
import objectContainsFalse from '../../helpers/objectContainsFalse.js'
import PhoneNumber from '../../components/PhoneNumber/PhoneNumber'
import FooterButton from '../../components/FooterButton/FooterButton'
import PropType from 'prop-types'
import RadioField from '../../components/RadioField/RadioField'
import Container from '../../components/Container/Container'
import callAPI from '../../helpers/callAPI'
import getStaticData from '../../helpers/getStaticData'
import { tagBookerDetailsPage } from '../../helpers/tag/dynamicPageview'
import { updateBookerDetails } from '../../actions/bookerDetails'
import { validateBookerDetails } from '../../actions/validation'
import addFocusKey from '../../helpers/addFocusKey'

const styleFieldInfo = {
  paddingTop: '0.5rem',
}

const styleFieldSpacing = {
  marginTop: '1rem',
}

class BookerDetails extends React.Component {
  state = {
    countryList: [],
    defaultCountry: {},
    showInputFeedback: false,
    labels: this.props.content('Booker Details'),
  }

  componentDidUpdate = prevProps => {
    const { bookerDetails, validateBookerDetails } = this.props
    if (prevProps.bookerDetails !== bookerDetails) {
      validateBookerDetails({
        salutation: bookerDetails.salutation.length > 0,
        phoneNumber: bookerDetails.phoneNumber.length > 0,
        firstName: validName(bookerDetails.firstName),
        lastName: validName(bookerDetails.lastName),
        emailAddress: validEmail(bookerDetails.emailAddress),
      })
    }
  }

  componentDidMount() {
    window.scrollTo(0, 0)
    this.getPhoneNumberDetails()
    tagBookerDetailsPage()
  }

  getPhoneNumberDetails = () => {
    const countryCodeApiUrlParams = getStaticData('sitecore')

    callAPI({
      url: `${countryCodeApiUrlParams.url.replace(
        /{id}/i,
        countryCodeApiUrlParams.phonenumbercountriesid
      )}?language=${countryCodeApiUrlParams.language}`,
    }).then(list => {
      const countryList = list.map(country => {
        return {
          key: country['ItemID'],
          label: country['Country'],
          countryCode: country['Phone country code'] || '',
          placeholder: country['Placeholder home phone'] || '123456789',
          range: country['Length home phone'],
        }
      })
      const defaultCountry = countryList.find(
        country =>
          country.key ===
          getStaticData('gossettings').defaultphonenumbervalidationid
      )
      this.setState({
        countryList: countryList.map(country => addFocusKey(country)),
        defaultCountry,
      })
    })
  }

  handlePhoneNumberChange = phoneNumber => {
    const updatedBookerDetails = { ...this.props.bookerDetails }
    Object.keys(phoneNumber).forEach(x => {
      updatedBookerDetails[x] = phoneNumber[x]
    })
    this.props.updateBookerDetails(updatedBookerDetails)
  }

  handleChange = (key, value) => {
    const updatedBookerDetails = { ...this.props.bookerDetails }
    updatedBookerDetails[key] = value
    this.props.updateBookerDetails(updatedBookerDetails)
  }

  goToNextStep = () => {
    if (objectContainsFalse(this.props.validation)) {
      this.setState({ showInputFeedback: true })
    } else {
      this.props.history.push('/group-details')
    }
  }

  render() {
    const { bookerDetails, validation } = this.props
    const {
      labels,
      defaultCountry,
      showInputFeedback,
      countryList,
    } = this.state
    return (
      <Container paddedBottom>
        <h1>
          <Icon name="mainbooker" className="summary__icon -blue" />
          {labels['Heading']}
        </h1>
        <form>
          <RadioField
            {...showInputFeedback && { isValid: validation.salutation }}
            selectedOption={bookerDetails.salutation}
            handleChange={this.handleChange}
            name="salutation"
            label={labels['Salutation']}
            errorMessage={labels['Salutation error']}
            options={[
              {
                label: labels['Mr'],
                value: 'Mr.',
              },
              {
                label: labels['Ms'],
                value: 'Ms.',
              },
            ]}
          />
          <TextField
            {...showInputFeedback && { isValid: validation.firstName }}
            value={bookerDetails.firstName}
            onChange={this.handleChange}
            label={labels['Firstname']}
            errorMessage={labels['First name error']}
            placeholder={labels['First name placeholder']}
            id="firstName"
            type="text"
            required
            name="fname"
            autoCompleteName="given-name"
            maxLength={20}
          />
          <p style={styleFieldInfo}>{labels['First name note']}</p>
          <TextField
            {...showInputFeedback && { isValid: validation.lastName }}
            value={bookerDetails.lastName}
            onChange={this.handleChange}
            label={labels['Lastname']}
            errorMessage={labels['Last name error']}
            placeholder={labels['Last name placeholder']}
            id="lastName"
            type="text"
            name="lname"
            autoCompleteName="family-name"
            required
            maxLength={50}
          />
          <p style={styleFieldInfo}>{labels['Last name note']}</p>
          <TextField
            value={bookerDetails.company}
            onChange={this.handleChange}
            label={labels['Company']}
            placeholder={labels['Company name placeholder']}
            subLabel={labels['Optional label']}
            id="company"
            name="organization"
            autoCompleteName="organization"
            type="text"
          />
          <div style={styleFieldSpacing}>
            <TextField
              {...showInputFeedback && { isValid: validation.emailAddress }}
              value={bookerDetails.emailAddress}
              onChange={this.handleChange}
              label={labels['Email']}
              errorMessage={labels['Email address error']}
              placeholder={labels['Email placeholder']}
              id="emailAddress"
              type="email"
              required
              name="email"
              autoCompleteName="email"
            />
          </div>
          <PhoneNumber
            {...showInputFeedback && { isValid: validation.phoneNumber }}
            {...bookerDetails}
            fieldLabel={labels['Phone number']}
            errorMessage={labels['Phone number error']}
            handleChange={this.handlePhoneNumberChange}
            countryList={countryList}
            defaultCountry={defaultCountry}
            autoFillName="phone"
            autoCompleteName="tel"
          />
        </form>
        <FooterButton
          buttonAction={() => this.goToNextStep()}
          buttonContent={labels['Group details Button Label']}
          backButtonContent={labels['Return Button Label']}
          backButtonLink="/ancillaries"
          iconName="arrow-right"
        />
      </Container>
    )
  }
}

BookerDetails.propTypes = {
  bookerDetails: PropType.object,
  validation: PropType.object,
  updateBookerDetails: PropType.func,
  validateBookerDetails: PropType.func,
  getPhoneNumber: PropType.func,
  content: PropType.func,
  history: PropType.object,
}

const mapStateToProps = state => {
  const {
    bookerDetails,
    validation: { bookerDetails: bookerDetailsValidation },
  } = state
  return {
    bookerDetails,
    validation: bookerDetailsValidation,
  }
}

const mapDispatchToProps = {
  updateBookerDetails,
  validateBookerDetails,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BookerDetails)
